/** Foroba's public legal page, on whichever host the app's API base points at. */
export function legalUrl(apiBase: string | undefined): string {
  return `${(apiBase ?? '').replace(/\/+$/, '')}/legal`
}
